export default {
  ESC: 27,
  DELETE: 46,
};
